var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;}.d{fill:#fcf2eb;}.e{fill:#c16833;}.f{fill:#e37b3c;}.g{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 20,
    cy: 19.5,
    r: 19.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 20,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32,33c0,6.63-5.37,7-12,7s-12-.37-12-7,5.37-12,12-12,12,5.37,12,12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 20,
    cy: 16.5,
    r: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSignIn);
export default __webpack_public_path__ + "static/media/not_sign_in.7d87a0e8ec09fd0afe39af652c9bc973.svg";
export { ForwardRef as ReactComponent };